import { render, staticRenderFns } from "./EditTitel.vue?vue&type=template&id=1f239f76"
import script from "./EditTitel.vue?vue&type=script&lang=ts"
export * from "./EditTitel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports